import styles from './card.module.less';

export function CardBody(props: {children?: any;}) {
	return (
		<div className={styles.cardBody}>
			{props.children}
		</div>
	);
}
